export default __webpack_public_path__ + "static/media/presentation-640.202bcc93.png";